import React from 'react';
import Parent from '../../common/parent';
import { withTranslation } from 'react-i18next';
import {BllinkLogger} from '../../common/utils/bllink_loggers';
import BuildingTitle from '../../common/buildingTitle';
import RewardsText from '../tenant_payments/rewards/rewardsText';
import PaymentNavBar from '../../common/payment_flow/paymentSections';
import PaymentMiddleContent from '../../common/payment_flow/paymentMiddleContent';
import BackToPersonalDetails from '../../common/payment_flow/backToPersonalDetails';
import { constants } from '../../common/constants/constants';
import CacheData from '../../common/utils/cacheData';
import $ from 'jquery';
import {GAEvent} from "../../common/google_analytics/google_analytics";
import LogPaymentsManagerNavBar from "../../common/manager_navbar/logPaymentsManagerNavBar";
import MonthSelectionInfoPopUp from "./monthSelectionInfoPopUp/MonthSelectionInfoPopUp";

const paymentsTypes = [
    {key: constants.serverContract.payments.onGoing, cacheKey: 'onGoingSelectedPayments'},
    {key: constants.serverContract.payments.past, cacheKey: 'debtSelectedPayments'},
    {key: constants.serverContract.payments.one_time, cacheKey: 'oneTimeSelectedPayments'},
]

export class SelectPayments extends Parent {

    constructor(props) {
        super(props);
        document.title = props.t('titles.payment_details');

        const isViewedAsManager = this.props.match.path.includes(constants.pages.paymentSelectionTabForManager);

        this.state = {
            isViewedAsManager: isViewedAsManager,
        }
        this.bindSelectPaymentsTab.bind(this)
        this.renderPaymentNavBar.bind(this)
        this.changeTab.bind(this)
    }

    async componentDidMount() {

        if (this.state.isViewedAsManager){
            await this.verifyLoggedIn();
            await this.getAuthenticatedClient();
        }

        let showMonthSelectionInfoPopUp;

        // added try catch to avoid https://sentry.io/organizations/bllink/issues/3293195961/?project=5424386&query=is%3Aunresolved
        // error: Unexpected token < in JSON at position 0
        try {
            showMonthSelectionInfoPopUp = !(JSON.parse(CacheData.fetchCache('showMonthSelectionInfoPopUp')) === false)
        } catch(err) {
            console.log(`select payment pop up error: ${err}`);
            showMonthSelectionInfoPopUp = true;
        }

        const tenantDetails = CacheData.fetchCache('tenantDetails');
        const isManager = this.state.isViewedAsManager;
        // the ownership will enable some filtering on server side, we will not use it for managers
        // to fix for https://sentry.io/organizations/bllink/issues/2695735062/?project=5424386&referrer=RegressionActivityEmail
        // null is not an object (evaluating 't.tenant_type')
        // NOTE: BE do not use the ownership parameter
        const ownership = isManager ? null : (tenantDetails ? tenantDetails.tenant_type :  null);
        const phone = tenantDetails?.phone;
        const { buildingID, apartmentNumber } = this.props.match.params;
        const buildingData = await this.fetchBuildingData(buildingID);
        try {
            const payments = await this.fetchApartmentPaymentData(buildingID, apartmentNumber, isManager, ownership, phone);
            if (payments) {
                await this.clearCacheIfPaymentsChanged(payments, buildingID, apartmentNumber);
                const paymentsActiveStats = this.paymentsActiveStats(payments)
                this.setState({
                    buildingID,
                    apartmentNumber,
                    ownership,
                    payments,
                    paymentsActiveStats,
                    address: buildingData.address,
                    phoneAuthenticationFailed: false,
                    finishedLoadDataFromBackend: true,
                    showMonthSelectionInfoPopUp,
                });
                this.bindSelectPaymentsTab();
                this.bindTabChangedEvent();
            }
        } catch (e) {
            const backUrl = `/${isManager ? constants.pages.tenantDetailsManagerUrl : constants.pages.tenantDetailsUrl}/${buildingID}`;
            this.bindBackNextClicked(backUrl, true);
        }

        $(document).ready(function () {
            // bootstrap modal append to body - https://stackoverflow.com/a/15780841/13806459
            // https://app.asana.com/0/1196545425570329/1198890480504266

            $(`#offline-payments-part-pay`).appendTo('body');
        });
    }

    async clearCacheIfPaymentsChanged(serverResponse, buildingID, apartmentNumber){
        /*
           clear cache if needed for debt / on going / one time payments
           this is in the case the server data is different than cached data
         */

        const options = { buildingID, apartmentNumber };
        for (const paymentType of paymentsTypes) {
            if (serverResponse[paymentType.key]) {
                let listOfPayments = serverResponse[paymentType.key];
                listOfPayments = Array.isArray(listOfPayments) ? listOfPayments : listOfPayments.paymentsSortedArray;
                this.clearSpecificCacheIfNeeded(listOfPayments, paymentType.cacheKey, options);
            } else {
                CacheData.delete(paymentType.cacheKey, options);
            }
        }

        await this.clearMaxDebtCacheIfNeeded(serverResponse[constants.serverContract.payments.past], options.buildingID)
    }

    async clearMaxDebtCacheIfNeeded(pastPayments, buildingID){
        // next line to avoid this error (https://sentry.io/organizations/bllink/issues/2222605730/events/472c993f0cd24188ae607523219121bd/events/?project=5424386)
        // when apartment is not found
        if (!pastPayments) {return }
        // https://app.asana.com/0/1196545425570329/1199921390217598
        // make maxDebt installments number instant
        let cachedMaxInstallment = await this.fetchMaxDebtInstallmentsFromCache(buildingID)
        let updatedMaxDebtInstallments = pastPayments.numberOfInstallments;
        if (updatedMaxDebtInstallments !== cachedMaxInstallment){
            BllinkLogger.info(`clearing building data due to max debt installments changed. fetching again`)
            CacheData.delete('buildingData', {buildingID: buildingID})
            await this.fetchBuildingData(buildingID)
        }
    }

    async clearSpecificCacheIfNeeded(specificPaymentsList, typeOfPayments, options){

        const cachedData = CacheData.fetchCache(typeOfPayments, options);
        if (cachedData == null) {
            return;
        }

        if (specificPaymentsList.length !== cachedData.length){
            return CacheData.delete(typeOfPayments, options);
        }

        specificPaymentsList.forEach((payment, index) => {
            const relevantCachedPayment = cachedData[index];
            if (parseFloat(payment.total.value) !== parseFloat(relevantCachedPayment.total.value)){
                return CacheData.delete(typeOfPayments, options);
            }

            //https://app.asana.com/0/1196545425570329/1199915077024255
            // Caching for one time installments
            let isOneTime = (payment.max_installments)
            if (isOneTime){
                if (payment.max_installments !== relevantCachedPayment.max_installments){
                    return CacheData.delete(typeOfPayments, options);
                }
            }
        })
    }

    paymentsActiveStats(payments){
        /*
            meant to show hide payments tabs if not relevant
            also report to google analytics
        */
        const monthlyIsEmpty = ((payments[constants.APIContract.fields.on_going] || {}).paymentsSortedArray || []).length === 0;
        const debtIsEmpty = ((payments[constants.APIContract.fields.past] || {}).paymentsSortedArray || []).length === 0;
        const oneTimeIsEmpty = (payments[constants.APIContract.fields.one_time_payments] || []).length === 0;

        let nonEmptyPayments = 0;
        if (!monthlyIsEmpty){
            nonEmptyPayments += 1
        }
        if (!debtIsEmpty){
            nonEmptyPayments += 1
        }
        if (!oneTimeIsEmpty){
            nonEmptyPayments += 1
        }


        GAEvent(constants.GoogleAnalytics.Events.selectPayments, 'non_empty', 1, `number_of_non_empty_${nonEmptyPayments}`);

        return {
            monthlyIsEmpty: monthlyIsEmpty,
            debtIsEmpty: debtIsEmpty,
            oneTimeIsEmpty: oneTimeIsEmpty,
            nonEmptyPayments: nonEmptyPayments
        }

    }

    bindSelectPaymentsTab(){

        const thisObj = this;
        $('.js-payments-tab a').click((e)=> {
            e.preventDefault();

            thisObj.changeTab($(e.target).attr('value'))
        })
    }

    changeTab(newTabName){
        BllinkLogger.info(`also removing all happy family background by default ${document.body.classList}`)
        document.body.classList.remove('paid_payment_body') // will remove the happy family background

        this.setState({
            tabSelected: newTabName
        })
    }

    bindTabChangedEvent(){
        const thisObj = this;
        document.addEventListener(`tabChangedTo_${constants.managerPaymentsOptions.cheque}`, (e) => {
            BllinkLogger.info('change to cheque')
            thisObj.changeTab(constants.pages.chequeTab);
        }, false );

        document.addEventListener(`tabChangedTo_${constants.managerPaymentsOptions.autoCheque}`, (e) => {
            BllinkLogger.info('change to auto cheque')
            thisObj.changeTab(constants.pages.chequeDepositTab);
        }, false );
    }

    renderPaymentNavBar(buildingID, apartmentNumber, tabSelected, finishedLoadDataFromBackend){
        return (
            <PaymentNavBar
                buildingID={buildingID}
                apartmentNumber={apartmentNumber}
                paymentTabSelected={tabSelected}
                paymentsData={this.state.payments}
                paymentsStats={this.state.paymentsActiveStats}
                finishedLoadDataFromBackend={finishedLoadDataFromBackend}
                isViewedAsManager={this.state.isViewedAsManager}
            />)
    }

    getDefaultTab(){

        if (!this.state.paymentsActiveStats){
            return constants.pages.debtTab
        }

        if (this.state.paymentsActiveStats.nonEmptyPayments <= 1){
            return constants.pages.debtTab
        }else if (this.state.paymentsActiveStats.debtIsEmpty){
            return constants.pages.onGoingTab
        }

        return constants.pages.debtTab
    }

    renderTopBar(){
        let searchParams = new URLSearchParams(window.location.search);
        let tabSelected = this.state.tabSelected || searchParams.get('tab') || this.getDefaultTab();
        BllinkLogger.info(`tabSelected is -> `, tabSelected );
        let buildingID = this.props.match.params.buildingID;
        let apartmentNumber = this.props.match.params.apartmentNumber;
        let finishedLoadDataFromBackend = this.state.finishedLoadDataFromBackend;
        let shouldShowNavBar = !this.state.phoneAuthenticationFailed && (tabSelected !== constants.pages.chequeTab && tabSelected !== constants.pages.chequeDepositTab);
        let paymentsNavBar = shouldShowNavBar ? this.renderPaymentNavBar(buildingID, apartmentNumber, tabSelected, finishedLoadDataFromBackend): '';

        return (
            <div className="row">

                <input id="building-id" readOnly value={buildingID} hidden={true}/>
                <input id="apartment-number" readOnly value={apartmentNumber} hidden={true}/>

                <div className="p-dept-section col-md-12">
                    <BackToPersonalDetails
                        buildingID={buildingID}
                        onNextBackChange={this.bindBackNextClickedFunc}
                        isViewedAsManager={this.state.isViewedAsManager}
                    />
                    <BuildingTitle
                        address={this.state.address}
                        apartmentNumber={this.state.apartmentNumber}
                    />

                    <RewardsText
                      payments={this.state.payments}
                    />

                </div>
                {paymentsNavBar}

            </div>
        )
    }

    renderHiddenPopUp(props) {
        const {t} = this.props;

        return (
        <div className="modal fade" id={`offline-payments-part-pay`}>
            <div className="modal-dialog new_modal_content">
                <input id="js-time-index" readOnly value={''} hidden={true}/>
                <input id="js-full-amount" readOnly value={''} hidden={true}/>
                <div className="modal-content n_content">
                    <div className="modal-header">
                        <h5 className="col-12 modal-title text-center" id="genericModalLabel">{t('offline_payments.partial_pay')}</h5>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="form-group text-center" id="stf-rbk">
                                <div className="stf-rbk-2">
                                    <label htmlFor="email">{t('offline_payments.payment')}</label>
                                    <input type="text" className="form-control bllink-input-border js-new-sum" name="for-fees" id="for-fees"/>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <button type="submit" id="cancelation">{t('offline_payments.cancellation')}</button>
                            </div>
                            <div className="col-sm-6">
                                <button type="submit" id="popup_submit">{t('offline_payments.confirmation')}</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }

    render() {

        let searchParams = new URLSearchParams(window.location.search);
        let buildingID = this.props.match.params.buildingID;
        let apartmentNumber = this.props.match.params.apartmentNumber;
        let finishedLoadDataFromBackend = this.state.finishedLoadDataFromBackend;

        return (
            <section>
                <div className="container">
                    {this.renderTopBar()}
                    {this.state.phoneAuthenticationFailed &&
                        <div className="row">
                            <p>Phone authentication failed</p>
                        </div>
                    }
                    {!this.state.phoneAuthenticationFailed &&
                        <div className="row">
                            <PaymentMiddleContent
                                paymentTabSelected={this.state.tabSelected || searchParams.get('tab') || this.getDefaultTab()}
                                paymentsData={this.state.payments}
                                paymentsStats={this.state.paymentsActiveStats}
                                buildingID={buildingID}
                                buildingData={this.state.building}
                                apartmentNumber={apartmentNumber}
                                finishedLoadDataFromBackend={finishedLoadDataFromBackend}
                                onNextBackChange={this.bindBackNextClickedFunc}
                                isViewedAsManager={this.state.isViewedAsManager}
                            />
                        </div>
                    }
                </div>
                {this.renderHiddenPopUp()}
                <MonthSelectionInfoPopUp
                  show={this.state.showMonthSelectionInfoPopUp}
                  setShow={show => this.setState({showMonthSelectionInfoPopUp: show})}
                />
            </section>
        )
    }
}


export default withTranslation()(SelectPayments);

